import React, { Component } from "react"
import styled from "styled-components"
import { SECONDARY_TEXT, ACTIVE_TEXT } from "./consts/colors"
import { TinyButtonWhite } from "./Button"
import Step from "./Step"
import Icon from "./Icons"
import Fade from "react-reveal/Fade"

const StepsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 980px) {
    margin: 0px 0px 50px 0px;
  }
`

const StepsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  h2 {
    font-size: 20px
    margin: 25px 0px 0px 0px;
  }
  p {
    font-size: 16px;
    line-height: 20px;
    margin: 25px 0px 10px 0px;
  }
  em {
    font-size: 14px;
    line-height: 17px;
    color: ${SECONDARY_TEXT};
  }
  a {
    display: flex;
    align-self: center;
    align-items: center;
    justify-content: center;
    transition: all 200ms ease;
    :hover {
      transform: translateX(3px);
    }
    div {
      padding-left: 10px;
      position: relative;
      top: 2px;
    }
  }
  @media screen and (max-width: 980px) {
    flex-direction: column;
    h2 {
      font-size: 18px
      margin: 25px 0px 0px 0px;
    }
    p {
      font-size: 15px;
      line-height: 19px;
      margin: 15px 0px 10px 0px;
    }
  }
`

const BigIcon = styled.div`
  transform: scale(1.8);
  margin: 0px 0px 25px 0px;
  @media screen and (max-width: 980px) {
    transform: scale(1.6);
    margin: 0px 0px 10px 0px;
  }
`

const StepsTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  h3 {
    font-weight: 400;
    font-size: 28px;
    margin: 10px 0px 25px 0px;
  }
  h1 {
  }
  @media screen and (max-width: 768px) {
    text-align: center;
  }
`

const Steps = props => (
  <StepsWrapper>
    <Fade bottom delay={50} duration={400}>
      <StepsTitle>
        <h1>We make getting started as easy as possible.</h1>
        <h3>(and it's completely free)</h3>
      </StepsTitle>
    </Fade>
    <StepsContainer>
      <Fade bottom delay={100} duration={400}>
        <Step>
          <BigIcon>
            <Icon name="product" color="#6079F2" />
          </BigIcon>
          <div>
            <h2>Design a Product.</h2>
            <p>
              Start filling your store with awesome creations. More product
              options coming soon!
            </p>
            <a href="https://my.tinymerch.com">
              Get Started!<Icon name="forward" color="#6079F2" />
            </a>
          </div>
        </Step>
      </Fade>
      <Fade bottom delay={150} duration={400}>
        <Step>
          <BigIcon>
            <Icon name="payment" color="#6079F2" />
          </BigIcon>
          <div>
            <h2>Setup up payment.</h2>
            <p>
              We’ll need you to do a quick verification to recieve payouts. We
              send profits to your bank account monthly.
            </p>
            {/* <em>Or you can choose to donate to a charity of your choice!</em> */}
            <a href="https://my.tinymerch.com">
              Get Started!<Icon name="forward" color="#6079F2" />
            </a>
          </div>
        </Step>
      </Fade>
      <Fade bottom delay={200} duration={400}>
        <Step>
          <BigIcon>
            <Icon name="code" color="#6079F2" />
          </BigIcon>
          <div>
            <h2>Add the script to your site.</h2>
            <p>
              Paste your custom script tag anywhere in the body of your website.
            </p>
            <a href="https://my.tinymerch.com">
              Get Started!<Icon name="forward" color="#6079F2" />
            </a>
          </div>
        </Step>
      </Fade>
    </StepsContainer>
  </StepsWrapper>
)
export default Steps



// WEBPACK FOOTER //
// ./src/components/Steps.js